var c = Object.defineProperty;
var p = (s, e, t) => e in s ? c(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var r = (s, e, t) => (p(s, typeof e != "symbol" ? e + "" : e, t), t);
const h = {};
function o(s) {
  try {
    const e = window[s], t = "__storage_test__";
    return e.setItem(t, t), e.removeItem(t), !0;
  } catch {
    return !1;
  }
}
const n = class {
  constructor() {
    r(this, "_prefix", "");
    r(this, "_type", "localStorage");
    r(this, "enabled", !1);
    r(this, "storage");
    this.enabled = o(this._type), this.storage = window[this._type];
  }
  static getInstance() {
    return n._instance || (n._instance = new n()), n._instance;
  }
  set type(e) {
    this._type = e, this.initialize(this._type);
  }
  get type() {
    return this._type;
  }
  set prefix(e) {
    this._prefix = e;
  }
  get prefix() {
    return this._prefix;
  }
  initialize(e) {
    this.enabled = o(e), this.storage = window[e];
  }
  _fillPrefix(e) {
    return !this.prefix || e && e.indexOf(this.prefix) === 0 ? e : `${this.prefix}${e}`;
  }
  get(e) {
    let t = {};
    if (e = this._fillPrefix(e), this.enabled) {
      const i = this.storage.getItem(e);
      i && (t = JSON.parse(i));
    } else
      t = h[e];
    if (t && t.data) {
      if (!t.expire || t.expire > new Date().getTime())
        return t.data;
      this.remove(e);
    }
  }
  set(e, t, i) {
    const f = {
      data: t
    };
    return e = this._fillPrefix(e), i && i > 0 && (f.expire = new Date().getTime() + i), this.enabled ? this.storage.setItem(e, JSON.stringify(f)) : h[e] = f, t;
  }
  getKeys() {
    let e = [], t = [];
    return this.enabled ? e = Object.keys(this.storage) : e = Object.keys(h), e.forEach((i) => {
      if (this.prefix) {
        const f = i.indexOf(this.prefix), l = this.prefix.length;
        f === 0 && t.push(i.substring(l));
      } else
        t.push(i);
    }), t;
  }
  remove(e) {
    e = this._fillPrefix(e), this.enabled ? this.storage.removeItem(e) : delete h[e];
  }
  removeAll() {
    this.getKeys().forEach((t) => {
      this.remove(t);
    });
  }
  removeExpired() {
    this.getKeys().forEach((t) => {
      this.get(t);
    });
  }
};
let a = n;
r(a, "_instance");
export {
  a as ReactStorage
};
